<template>
    <div class="wrap">
        <p class="tips-top">您的当前位置：老年教育&lt;招生报名</p>
        <div class="top-btn-box">
            <span class="btn-type">类型：</span>
            <span
                @click="changeType(1)"
                :class="[type == 1 ? 'top-btn-active' : '', 'top-btn']"
                >招生简章</span
            >
            <span
                @click="changeType(2)"
                :class="[type == 2 ? 'top-btn-active' : '', 'top-btn']"
                >在线报名</span
            >
        </div>
        <div v-if="type == 1" class="jianzhang">
            <h2 class="zhao-title">
                {{ zhaoData.title }}
            </h2>
            <p class="zhao-time">
                时间：{{
                    zhaoData.creaTime && zhaoData.creaTime.time | dateFormat
                }}
            </p>
            <div class="detail" v-html="zhaoData.description"></div>
        </div>
        <div v-if="type == 2" class="baoming">
            <div class="jianzhang">
                <div class="detail" v-html="zaixianData.description"></div>
            </div>
            <table class="oneTable">
                <thead>
                    <tr>
                        
                        <td>序号</td>
                        <td>专业名称</td>
                        <td>课程代码</td>
                        <td>课程(班)</td>
                        <td>任课教师</td>
                        <td>招生人数</td>
                        <td>上课日期</td>
                        <td>上课时间</td>
                        <td>学习内容</td>
                        <td>报名要求</td>
                        <td>报名时间</td>
                        <td>面试时间</td>
                        <td>面试地点</td>
                        <td>操作</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in baoData.list" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.signPName }}</td>
                        <td>{{ item.courseCode }}</td>
                        <td>{{ item.signName }}</td>
                        <td>{{ item.teacherName }}</td>
                        <td>{{ item.studentNum }}</td>
                        <td>{{ item.courseDate }}</td>
                        <td>{{ item.courseTime }}</td>
                        <td :title="item.courseContent">
                            {{
                                item.courseContent.length > 30
                                    ? item.courseContent.substring(0, 30) +
                                      "..."
                                    : item.courseContent
                            }}
                        </td>
                        <td :title="item.requirement">
                            {{
                                item.requirement.length > 30
                                    ? item.requirement.substring(0, 100) + "..."
                                    : item.requirement
                            }}
                        </td>
                        <td>{{ item.enterTime }}</td>
                        <td>{{ item.interviewTime }}</td>
                        <td>{{ item.interviewAdress }}</td>
                        <td class="lastTd">
                            <span
                                :class="[
                                    'baseCss',
                                    item.state == 1
                                        ? 'canSignIn'
                                        : item.state == 2
                                        ? 'signIned'
                                        : item.state == 3
                                        ? 'passed'
                                        : 'notstart'
                                ]"
                                @click="goSignIn(item)"
                                >{{
                                    item.state == 1
                                        ? "在线报名"
                                        : item.state == 2
                                        ? "已报名"
                                        : item.state == 3
                                        ? "已截止"
                                        : "未开始"
                                }}</span
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
		<!-- <div class="hoverContent">{{hoverMessage}}</div> -->
    </div>
</template>
<script>
export default {
    name: "online",
    data() {
        return {
            type: 1,
            zhaoData: {},
            zaixianData: {},
            baoData: {
                list: [],
                totalPage: 0
            },
          
        };
    },
    created() {
        if (this.$route.query.type == 2) {
            this.type = 2;
            this.getZixunData(46);
            this.getBaolistData();
        } else {
            this.type = 1;
            this.getZixunData(42);
        }
    },
    methods: {
        goSignIn(item) {
            if (parseInt(item.state) == 1) {
                if (this.$store.state.hasLogin) {
                    this.$router.push({
                        name: "signUp",
                        query: {
                            id: item.id
                        }
                    });
                } else {
                    this.$router.push({
                        name: "login"
                    });
                }
            }
        },
        changeType(type) {
            this.type = type;
            if (this.type == 2) {
             this.getZixunData(46);
                this.getBaolistData();
            } else {
                this.getZixunData(42);
            }
        },
        getZixunData(navId, page = 1) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: navId,
                    curren: page
                },
                success: res => {
                    console.log(res.code)
                    if (res.code == 200) {
                        console.log(res.message.records[0])
                        if (this.type == 2) {
                            this.zaixianData = res.message.records[0];
                        } else {
                            this.zhaoData = res.message.records[0];
                        }
                    }
                    if(res.code == 500) {
                        this.zhaoData.description = ''
                    }
                }
            });
        },
        getBaolistData(page = 1) {
            this.$ajax({
                method: "post",
                url: "homePage/getCUR",
                data: {
                    token: this.$store.state.userToken
                        ? this.$store.state.userToken
                        : "",
                    curren: page
                },
                success: res => {
                    if (res.code == 200) {
                        console.log(res.message.records)
                        this.baoData.list = res.message.records;

                        this.baoData.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                    }
                }
            });
        }
    }
};
</script>
<style scoped="scoped" lang="scss">
.wrap {
    width: 1000px;
    min-height: 500px;
    margin: 0 auto;
    .tips-top {
        margin: 5px 0;
        color: #999;
        font-size: 16px;
    }
    .top-btn-box {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #ddd;
        margin-bottom: 30px;
        .top-btn {
            margin-left: 30px;
            cursor: pointer;
        }
        .top-btn-active {
            font-weight: bold;
        }
    }
    .jianzhang {
        width: 1000px;
        min-height: 500px;
        .zhao-title {
            font-size: 30px;
        }
        .zhao-time {
            font-size: 16px;
            color: #666;
            padding: 20px 0;
        }
        .detail {
            width: 1000px;
        }
    }
    .baoming {
        width: 1000px;
        min-height: 500px;
        .jianzhang {
            width: 1000px;
            min-height: 0;
            .zhao-title {
                font-size: 30px;
            }
            .zhao-time {
                font-size: 16px;
                color: #666;
                padding: 20px 0;
            }
            .detail {
                width: 1000px;
            }
        }
        .title {
            width: 100%;
            text-align: center;
            font-weight: 600;
            padding: 10px 0;
            font-size: 18px;
        }

        .text {
            font-size: 15px;
        }

        .text p {
            padding: 10px 0;
        }

        .oneTable {
            margin-top: 50px;
            width: 1000px;
            text-align: center;
            font-size: 14px;
        }

        .oneTable td {
            border: 1px solid black;
            padding: 5px;
            word-break: break-all;
        }

        .lastTd {
            width: 70px;
            // 可以报名
            .baseCss {
                min-width: 60px;
                display: inline-block;
                padding: 2px 5px;
                border-radius: 4px;
                border: 1px solid #666;
                cursor: pointer;
            }
            .canSignIn {
                background-color: #669933;
                color: #fff;
            }
            .canSignIn:hover {
                background-color: #336600;
            }
            // 已报名
            .signIned {
                background-color: #669999;
                color: #fff;
                cursor: not-allowed;
            }
            // 已过期
            .passed {
                background-color: #cccccc;
                color: #000;
                cursor: not-allowed;
            }
            // 未开始
            .notstart {
                background-color: #cccccc;
                color: #000;
                cursor: not-allowed;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/lnjy/online.vue